module.exports = __webpack_public_path__ + "media/bootstrap-icons/sort-numeric-up-4d07d321.svg";